@if (isOpen) {
<div class="cd-overlay" (click)="onCancel()">
  <div class="cd-modal" (click)="$event.stopPropagation()">
    <h3 class="cd-title">{{ title }}</h3>
    @if (message) {
    <p class="cd-message">{{ message }}</p>
    }
    <div class="cd-actions">
      <button type="button" class="cd-btn cd-btn-cancel" (click)="onCancel()">{{ cancelLabel }}</button>
      <button type="button" class="cd-btn cd-btn-confirm" [class.cd-btn-confirm--danger]="danger"
        (click)="onConfirm()">{{ confirmLabel }}</button>
    </div>
  </div>
</div>
}
